import Hero from "../../components/Hero";
import EquityReleaseImage from "../../../assets/images/Equity1.jpg";
import EquityReleaseImage1 from "../../../assets/images/Equity 2.jpg";

const EquityRelease = () => {
  return (
    <div>
      <Hero
        backgroundImage={EquityReleaseImage}
        title="Equity Release"
        subtitle="OUR SERVICES"
      />
      <div className="footer-legal">
        <div className="footer-legal-text">
          <div className="column align-center">
            <div className=" content-semibold primary">
              THIS SERVICE IS REFERRED TO A THIRD PARTY.
            </div>
          </div>
        </div>
      </div>
      <div className="landing-page">
        <div className="column align-center">
          <div className="content primary">
            If you're a homeowner over the age of 55, equity release offers you
            a way to use the value of your home to raise money. You won’t have
            to make monthly repayments but the debt will eventually have to be
            repaid – with interest.
          </div>
          <div className="content primary">
            It is advised that you seek Independent Legal advice before entering
            into a legally binding equity release contract.
          </div>
        </div>
      </div>
      <div className="primary-container primary">
        <div className="light-row">
          <div className="column primary align-left ">
            <div className="content-semibold">
              Why do people consider Equity Release?
            </div>
            <ul className="military-insurance-list white">
              <li>To provide an additional income in retirement</li>
              <li>To provide lifetime gifts to relatives</li>
              <li>For home improvements</li>
              <li>For holiday home purchase</li>
              <li>To fund long-term care</li>
            </ul>
          </div>
          <img
            src={EquityReleaseImage1}
            className="landing-page-image"
            alt="Landing Page 3"
          />
        </div>
      </div>
      <div className="footer-legal">
        <div className="footer-legal-text">
          <div className="column align-center">
            <div className=" content primary">
              Equity release has to fit with your needs, circumstances and
              preferences, where the benefits need to outweigh the drawbacks and
              be more suitable than alternative methods of raising funds.
            </div>
          </div>
        </div>
      </div>
      <div className="landing-page">
        <div
          className="column align-center"
          style={{ marginTop: "30px", marginBottom: "30px" }}
        >
          <div className="content-semibold primary">
            EQUITY RELEASE WILL REDUCE THE VALUE OF YOUR ESTATE AND CAN AFFECT
            YOUR ELIGIBILITY FOR MEANS TESTED BENEFITS.
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquityRelease;
